// Componente principal de la página de elaboración de presupuestos.
// Se compone de 2 partes diferenciadas:
// - Tabla resumen del presupuesto para cada mes y cada zona
// - Herramienta de generación automática de un presupuesto a partir de otro ya existente

// Se trabaja con 2 presupuestos, uno provisional y uno definitivo, de forma que se puede trabajar con el presupuesto provisional sin modificar 
// el que tenemos guardado como definitivo. 
// Una vez satisfechos con el presupuesto provisional, éste se puede convertir en definitivo, sustituyendo al presupuesto definitivo existente.
// El presupuesto definitivo también se puede convertir en provisional, sustituyendo el provisional existente.

// Resumen del presupuesto:
//         
//      Selectores:
//          - centro
//          - año
//          - definitivo / provisional
//      Botón de copia de: guardar presupuesto provisional como definitvo / copiar presupuesto definitivo a provisional
//      Botón de bloquear presupuesto para evitar modificación
//      Tabla de resumen del preupuesto
//          - Cada columna es un tipo de zona
//          - Cada fila es un més del año
//          - Cada fila tiene un botón de editar que abre la ventana de edición del presupuesto, dónde se puede editar el valor de presupuesto diario        
//      Indicador de % Bar/Bolera
//      Indicador de ingresos totales del presupuesto
//
//
// Generador de presupuesto:
//
//      Selectores:
//          - año
//          - valores reales o del presupuesto
//          - meses a generar
//      Tabla con cada zona y el incremento o importe objetivo que se quiere generar
//      Botón para rellenar la tabla aplicando un incremento a todo el presupuesto origen
//      Botón para generar el presupuesto a partir de los datos de la tabla
//

// Generación del presupuesto a partir de un presupuesto de origen
// Llama a la API (presupuesto/generaPresupuesto) que genera el presupuesto teniendo en cuenta el valor importe objetivo (columna Importe )
// Cuando se modifica la columna % se incrementa el valor de la columna importe el porcentaje indicado
//
// Para generar el importe, la API calcula cuál es el factor resultante de la diferencia de los importes y modifica en ese factor los
// valores de los dias correspondientes.
// Los valores no corresponden al mismo día del mes, sino que corresponden al día equivalente del meés objetivo teniendo en cuenta los días de la semana, 
// por tanto el importe generado se aproximará al importe objetivo pero puede no coincidir exactamente


import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import update from 'immutability-helper';
import uuidv4 from 'uuid';

import PropTypes from 'prop-types';
import { navigate } from '../../actions';
import { getAllCentros } from '../../actions/centro_actions';
import { getPresupuesto, generatePresupuesto, copiarPresupuesto, cambiarBloqueoPresupuesto } from '../../actions/presupuesto_actions';
import { openDialog, hideDialog } from '../../actions/index';
import { setCentroDia } from '../../actions/centro_dia_actions';

import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { Button } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';

//components:
import NeuriteGrid from '../../components/neurite_grid';
import FloatNumberFormatInput from '../../components/float_number_input_formatter';
import FloatPercentFormatInput from '../../components/float_percent_input_formatter';

//helpers:
import { getData, postData } from '../../dataLib';

import * as config from '../../constants/configuration';


const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    formControl: {
        margin: theme.spacing(2),
        minWidth: 120,
    },
    centroSelect: {
        maxWidth: 240
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    spinnerContainer: {
        width: '95%',
        height: 220,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    inputImporte: {
        textAlign: 'right',
        margin: theme.spacing(1),
        padding: 0,
        fontSize: 12,
    },
    inputRefTotal: {
        position: 'relative',
        marginRight: 20,
        left: 50 - theme.spacing(1),
        width: 100,
    },
    inputNewTotal: {
        position: 'relative',
        marginRight: 20,
        left: 50 - theme.spacing(1),
        width: 100,
    },
    inputPercentTotal: {
        position: 'relative',
        marginRight: 20,
        left: 50 - theme.spacing(1),
        width: 100,
    },
    totales: {
        display: 'flex'
    },
    input: {
        marginRight: theme.spacing(3)
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    buttonIncremento: {
        position: 'relative',
        marginLeft: theme.spacing(1),
        padding: '10px 2%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        fontSize: 12,
        width: 170
    },
    buttonCopy: {
        // position: 'relative',
        // marginLeft: theme.spacing(1),
        // padding: '10px 20px',
        borderRadius: 0,
        textTransform: 'none',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        fontSize: 13,
        width: 170,
        height: 48
    },
    buttonLock: {
        // margin: theme.spacing(1),
        // padding: 10,
        borderRadius: 0,
        border: 'none',
        boxShadow: 'none',
        height: 48
    },
    divOptions: {
        display: 'flex',
    }
});

class EntPresupuestos extends Component {

    constructor(props) {
        super(props);

        this.state = {
            centroSelected: this.props.centroDiaSelected.centro ? this.props.centroDiaSelected.centro.id : 1,
            //centroOrigenSelected: this.props.centroDiaSelected.centro ? this.props.centroDiaSelected.centro.id : 1,
            yearSelected: new Date().getFullYear(),
            yearOrigenSelected: 1900,
            totalOrigen: 0.0,
            totalRefPresupuesto: 0.0,
            totalPresupuesto: 0.0,
            totalPercentPresupuesto: 0.0,
            //rowsCoefs: [],
            rowsGenerarPresupuesto: [],
            loadingGenerarGrid: false,
            real: true,
            realOrPpto: 'real',
            startMonthOrigen: 1,
            endMonthOrigen: 12,
            provisionalOrDefinitivo: 'definitivo'
        };
    };

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        // if (this.props.presupuesto.reload) {
        if (this.props.centros.find(c => c.id === this.state.centroSelected) !== undefined) {
            this.props.getPresupuesto(this.state.centroSelected, this.state.yearSelected, this.state.provisionalOrDefinitivo === 'provisional');
        }
        // }
        // else {
        //     const year = this.getFirstOriginYear();
        //     this.setState({ ...this.state, yearOrigenSelected: year });
        //     this.fillGeneratePresupuestoValues(year);
        // }

    };

    componentDidUpdate = (prevProps, prevState) => {

        if (this.props.presupuesto.reload) { //se tiene que recargar el presupuesto
            if (this.props.centros.find(c => c.id === this.state.centroSelected) !== undefined) {
                this.props.getPresupuesto(this.state.centroSelected, this.state.yearSelected, this.state.provisionalOrDefinitivo === 'provisional');
            }
        }
        else {
            if (prevProps.presupuesto.presupuesto !== this.props.presupuesto.presupuesto) {
                if (!this.props.presupuesto.isLoading && this.props.centros.find(c => c.id === this.state.centroSelected) !== undefined) {

                    if (this.state.yearOrigenSelected === 1900) {
                        const year = this.getFirstOriginYear();
                        this.fillGeneratePresupuestoValues(year);
                    }
                    else {
                        if (prevProps.presupuesto.presupuesto.centroId !== this.props.presupuesto.presupuesto.centroId) {
                            const year = this.getFirstOriginYear();
                            this.fillGeneratePresupuestoValues(year, true);
                        }
                    }
                }
            }
            else {

                if (this.props.presupuesto.copied) {
                    const value = this.state.provisionalOrDefinitivo === 'provisional' ? 'definitivo' : 'provisional';
                    this.setState({ ...this.state, provisionalOrDefinitivo: value });
                    this.props.getPresupuesto(this.state.centroSelected, this.state.yearSelected, value === 'provisional');
                }
                else {
                    if ((prevState.startMonthOrigen !== this.state.startMonthOrigen ||
                        prevState.endMonthOrigen !== this.state.endMonthOrigen ||
                        prevState.realOrPpto !== this.state.realOrPpto) && !this.props.presupuesto.isLoading) {
                        this.fillGeneratePresupuestoValues(this.state.yearOrigenSelected);
                    }
                }

            }
        }
    }

    processRows = (rows) => {
        let totalRef = 0.0;
        let totalNew = 0.0;
        let totalPercent = 0.0;

        let newRows = rows.slice();

        newRows.forEach((r) => {
            const newValue = Math.round(r.newValue * 100) / 100;
            const refValue = Math.round(r.refValue * 100) / 100;
            totalRef += refValue;
            totalNew += newValue;
            let diff = newValue - refValue;
            r.percent = (diff / refValue) * 100;
        });

        totalPercent = ((totalNew - totalRef) / totalRef) * 100;

        this.setState({
            ...this.state,
            rowsGenerarPresupuesto: newRows,
            loadingGenerarGrid: false,
            totalRefPresupuesto: totalRef,
            totalPresupuesto: totalNew,
            totalPercentPresupuesto: totalPercent
        })
    };


    fillGeneratePresupuestoValues = (year, reset = false) => {

        this.setState({ ...this.state, loadingGenerarGrid: true, yearOrigenSelected: year });

        const rows = this.props.presupuesto.presupuesto.zonas.map((z, i) => {

            let centro_id = this.state.centroSelected

            if (!reset && this.state.rowsGenerarPresupuesto[i] !== undefined) centro_id = this.state.rowsGenerarPresupuesto[i].centroId;

            return {
                iTipoZonaId: z.iTipoZona,
                name: z.descr,
                //centroId: this.state.rowsGenerarPresupuesto[i] !== undefined ? this.state.rowsGenerarPresupuesto[i].centroId : this.state.centroSelected,
                centroId: centro_id,
                refValue: 0,
                newValue: 0,
                percent: 100
            }
        });

        let URL = 'Presupuesto/fillRefValues?ref_year=' + year + '&start_month=' + this.state.startMonthOrigen + '&end_month=' + this.state.endMonthOrigen + '&real=' + (this.state.realOrPpto === 'real');

        postData(URL,
            (response) => {

                this.processRows(response.data);

            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'error obteniendo valores para el nuevo presupuesto'
                }, uuidv4(), false, 'sm');
            },
            rows,
            this.props.user
        );

    }


    getFirstOriginYear = () => {
        if (this.props.presupuesto.presupuesto.refYearsPpto.length === 0) return new Date().getFullYear();
        return this.props.presupuesto.presupuesto.refYearsPpto[0].year;
    }

    getYearTotal = (year, real) => {
        return real ?
            this.props.presupuesto.presupuesto.refYearsReal.find(y => y.year === year).total
            : this.props.presupuesto.presupuesto.refYearsPpto.find(y => y.year === year).total;
    }

    handleSelectCentrosValueChange = (event) => {
        var centroSelected = this.props.centros.find(c => c.id === parseInt(event.target.value));
        if (centroSelected !== undefined) {
            this.setState({ ...this.state, centroSelected: parseInt(event.target.value), loadingGenerarGrid: true })
            this.props.getPresupuesto(parseInt(event.target.value), this.state.yearSelected, this.state.provisionalOrDefinitivo === 'provisional');
            this.props.setCentroDia(parseInt(event.target.value), undefined, false);
        }
    }

    handleYearValueChange = (event) => {
        this.setState({ ...this.state, yearSelected: event.target.value });
        this.props.getPresupuesto(this.state.centroSelected, event.target.value, this.state.provisionalOrDefinitivo === 'provisional');
    }

    handleYearOrigenValueChange = (event) => {
        //const totalOrigen = this.props.presupuesto.presupuesto.refYearsPpto.find(y => y.year === parseInt(event.target.value)).total;
        this.fillGeneratePresupuestoValues(parseInt(event.target.value));
        //this.setState({ ...this.state, yearOrigenSelected: parseInt(event.target.value), totalOrigen: totalOrigen });
        this.setState({ ...this.state, yearOrigenSelected: parseInt(event.target.value)});
    }


    renderSelectYears = () => {

        let years = [];
        const actualYear = new Date().getFullYear();

        years.push(actualYear);
        years.push(actualYear + 1);
        years.push(actualYear + 2);
        years.push(actualYear + 3);
        years.push(actualYear - 1);

        return (
            years.map(y => {
                return (<MenuItem key={'year_' + y} value={y}>{y}</MenuItem>);
            })
        );

    };

    renderSelectOrigenYears = () => {

        const anyos = [];

        if (this.props.presupuesto.presupuesto.refYearsPpto || this.props.presupuesto.presupuesto.refYearsReal) {
           
            this.props.presupuesto.presupuesto.refYearsPpto.forEach(y => {
                anyos.push(y.year);
            });

            this.props.presupuesto.presupuesto.refYearsReal.forEach(y => {
                if (!anyos.includes(y.year)) anyos.push(y.year);
            });

            anyos.sort(function (a, b) { return a - b });

            return anyos.map(y => {
                return (<option key={'year_' + y} value={y}>{y}</option>);
            })

        }
    }

    handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {

        if (fromRow !== toRow) return; //we only allow modficiation of a single row

        var rows = this.state.rowsGenerarPresupuesto.slice();

        let updatedRow = update(this.state.rowsGenerarPresupuesto[fromRow], { $merge: updated });
        if(updated['percent'] !== undefined){
            updatedRow.newValue = updatedRow.refValue  + (updatedRow.refValue * updatedRow.percent / 100);
        }
        rows[fromRow] = updatedRow;

        if (updated['centroId'] !== undefined) { //modified centro

            let URL = 'Presupuesto/ImporteZonaCentro?centro_id=' + updatedRow.centroId + '&ref_year=' + this.state.yearOrigenSelected + '&i_tipozona=' + updatedRow.iTipoZonaId +
                '&real=' + (this.state.realOrPpto === 'real');

            getData(URL,
                (response) => {
                    rows[fromRow].refValue = response.data;
                    rows[fromRow].newValue = response.data;
                    this.processRows(rows);
                },
                (error) => {
                    this.props.openDialog('SimpleMessage', {
                        message: 'ERROR obteniendo importe'
                    }, uuidv4(), false, 'sm');
                },
                this.props.user
            );
            
            this.processRows(rows);

        }
        else {

            this.processRows(rows);
        }

    };


    editPresupuesto = (presupuesto) => {
        //this.props.navigate("presupuesto_detalle/" + presupuesto.iMes);
        this.props.openDialog("PresupuestoDetalle", { mes: presupuesto.iMes, presupuesto_id: this.props.presupuesto.presupuesto.id, cerrado: this.props.presupuesto.presupuesto.cerrado }, 'presupuesto_detalle', true, 'sm');
    };

    renderGrid = () => {

        const { classes } = this.props;

        if (this.props.presupuesto.isLoading) {
            return (
                <div className={classes.spinnerContainer}>
                    <CircularProgress className={classes.spinner} color="primary" />
                </div>
            )

        }
        else {
            var columns = [];
            columns.push({ key: 'mes', name: 'Mes', editable: false, dragable: false, width: 80 });

            let totalesZona = {};

            if (this.props.presupuesto.presupuesto.zonas) {
                this.props.presupuesto.presupuesto.zonas.forEach((z, index) => {
                    columns.push({ key: 'zona_' + z.iTipoZona, name: z.descr, editable: false, dragable: false, width: 120, type: 'float', grayField: 'isGray' });
                    totalesZona['zona_' + z.iTipoZona] = z.importe;
                });

                columns.push({ key: 'total', name: 'Total', editable: false, dragable: false, width: 80, type: 'float', grayField: 'isGrayTotal' });
            }
            else columns.push({ key: 'total', name: 'Total', editable: false, dragable: false, width: 1000 });

            var rows = [];
            if (this.props.presupuesto.presupuesto.valores) {
                this.props.presupuesto.presupuesto.valores.forEach((v, index) => {
                    let valores = {};
                    v.valores.forEach(v => {
                        valores['zona_' + v.iTipoZona] = v.importe;
                    })
                    rows.push({
                        iMes: index,
                        mes: v.mes,
                        ...valores,
                        total: v.importe,
                        isGrayTotal: true
                    })
                });

                rows.push({
                    mes: 'Total',
                    ...totalesZona,
                    isGray: true,
                    isGrayTotal: false
                })

            }
            else {
                rows.push({ mes: 'enero' });
                rows.push({ mes: 'enero' });
                rows.push({ mes: 'enero' });
                rows.push({ mes: 'enero' });
                rows.push({ mes: 'enero' });
                rows.push({ mes: 'enero' });
                rows.push({ mes: 'enero' });
                rows.push({ mes: 'enero' });
                rows.push({ mes: 'enero' });
                rows.push({ mes: 'enero' });
                rows.push({ mes: 'enero' });
                rows.push({ mes: 'enero' });
            }

            return (
                <NeuriteGrid
                id="e_p_1"
                    columns={columns}
                    rows={rows}
                    buttonEdit={true}
                    buttonDelete={false}
                    buttonNew={false}
                    onEditClick={this.editPresupuesto}

                />
            )

        }

    }


    renderGenerarPresupuestosGrid = (centros) => {
        const { classes } = this.props;

        if (this.state.loadingGenerarGrid) {
            return (
                <div className={classes.spinnerContainer}>
                    <CircularProgress className={classes.spinner} color="primary" />
                </div>
            )
        }
        else {
            var columns = [];
            columns.push({ key: 'name', name: 'Zona', editable: false, dragable: false, width: 80 });
            columns.push({ key: 'centroId', name: 'Centro', editable: true, dragable: false, width: 120, type: 'dropdown' });
            columns.push({ key: 'refValue', name: 'Importe referencia', editable: false, dragable: false, width: 120, type: 'float' });
            columns.push({ key: 'newValue', name: 'Importe', editable: true, dragable: false, width: 120, type: 'float' });
            columns.push({ key: 'percent', name: '%', editable: true, dragable: false, width: 120, type: 'percent' });

            const options = centros.map(centro => {
                return { id: centro.id, value: centro.id, text: centro.centro }
            })

            return (
                <NeuriteGrid
                id="e_p_2"
                    columns={columns}
                    rows={this.state.rowsGenerarPresupuesto}
                    buttonEdit={false}
                    buttonDelete={false}
                    buttonNew={false}
                    onRowsUpdated={this.handleGridRowsUpdated}
                    dropdownOptions={{
                        centroId: options
                    }}
                />
            );

        }
    }

    incrGrid = (newTotal) => {

        //double factor = destNuevo / origen;
        const factor = newTotal / this.state.totalRefPresupuesto;

        const rows = this.state.rowsGenerarPresupuesto.map(row => {

            return { ...row, newValue: row.refValue * factor };

        });

        this.processRows(rows);

    }

    handleRealChange = (event) => {
        this.setState({ ...this.state, realOrPpto: event.target.value });
    }


    handleProvisionalChange = (event) => {
        this.setState({ ...this.state, provisionalOrDefinitivo: event.target.value });
        if (this.props.centros.find(c => c.id === this.state.centroSelected) !== undefined) {
            this.props.getPresupuesto(this.state.centroSelected, this.state.yearSelected, event.target.value === 'provisional');
        }
    }

    renderMonths = () => {
        return ([
            <option key={'month_1'} value={1}>Enero</option>,
            <option key={'month_2'} value={2}>Febrero</option>,
            <option key={'month_3'} value={3}>Marzo</option>,
            <option key={'month_4'} value={4}>Abril</option>,
            <option key={'month_5'} value={5}>Mayo</option>,
            <option key={'month_6'} value={6}>Junio</option>,
            <option key={'month_7'} value={7}>Julio</option>,
            <option key={'month_8'} value={8}>Agosto</option>,
            <option key={'month_9'} value={9}>Septiembre</option>,
            <option key={'month_10'} value={10}>Octubre</option>,
            <option key={'month_11'} value={11}>Noviembre</option>,
            <option key={'month_12'} value={12}>Diciembre</option>
        ]);
    }

    handleStartMonthOrigenValueChange = (event) => {
        if (this.state.endMonthOrigen >= parseInt(event.target.value)) {
            this.setState({ ...this.state, startMonthOrigen: parseInt(event.target.value) });
        }
    }

    handleEndMonthOrigenValueChange = (event) => {
        if (this.state.startMonthOrigen <= parseInt(event.target.value)) {
            this.setState({ ...this.state, endMonthOrigen: parseInt(event.target.value) });
        }
    }

    handleLockClick = () => {

        this.props.cambiarBloqueoPresupuesto(this.props.presupuesto.presupuesto.id);
    }

    render() {

        const { classes } = this.props;

        let perfil = undefined;

        let centros = [];

        if (this.props.userProfile.selectedCentroProfile) {

            perfil = this.props.userProfile.selectedCentroProfile.iPerfil;

            centros = [0, 4, 5, 17, 20].includes(perfil) ?
                this.props.centros.filter(c => c.isGroup === false && c.activo === 1)
                : this.props.centros.filter(c => c.id === this.props.userProfile.selectedCentroProfile.centroId && c.isGroup === false && c.activo === 1);
        }

        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div>
                    <FormControl className={classes.formControl}>
                        <InputLabel>Centro</InputLabel>
                        <Select className={classes.centroSelect}
                            native
                            value={this.state.centroSelected}
                            onChange={(event) => this.handleSelectCentrosValueChange(event)}
                            name="centroId"
                        >
                            {centros.find(c => c.id === this.state.centroSelected) === undefined ? <option key={'centro_0'} value={0}>{"Seleccione un centro"}</option> : ''}
                            {centros.map(centro => {
                                return (<option key={'centro_' + centro.id} value={centro.id}>{centro.centro}</option>)
                            })}
                        </Select>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <InputLabel>Año</InputLabel>
                        <Select
                            value={this.state.yearSelected}
                            onChange={(event) => this.handleYearValueChange(event)}
                            name={'year'}
                        >
                            {this.renderSelectYears()}

                        </Select>
                    </FormControl>
                    <FormControl component="fieldset" className={classes.formControl} variant='outlined'>
                        <RadioGroup row
                            aria-label="Provisional"
                            name="optProvisional"
                            className={classes.group}
                            value={this.state.provisionalOrDefinitivo}
                            onChange={(event) => this.handleProvisionalChange(event)}
                        >
                            <FormControlLabel value={'definitivo'} control={<Radio />} label={'Definitivo'} />
                            <FormControlLabel value={'provisional'} control={<Radio />} label={'Provisional'} />
                        </RadioGroup>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.buttonCopy}
                            disabled={this.props.presupuesto.presupuesto.id === undefined || this.props.presupuesto.presupuesto.id === -1 || this.props.presupuesto.isLoading}
                            onClick={() => {
                                this.props.copiarPresupuesto(this.props.presupuesto.presupuesto.id, this.state.provisionalOrDefinitivo === 'provisional');
                            }}>
                            {this.state.provisionalOrDefinitivo === 'provisional' ? 'Guardar como definitivo' : 'Copiar a provisional'}
                        </Button>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <IconButton
                            color="secondary"
                            className={classes.buttonLock}
                            aria-label="Bloquear"
                            disabled={
                                this.props.presupuesto.presupuesto.id === undefined ||
                                this.props.presupuesto.presupuesto.id === -1 ||
                                this.props.presupuesto.isLoading || ![0, 4, 5, 17, 20].includes(perfil) ||
                                this.state.provisionalOrDefinitivo === 'provisional'}
                            onClick={this.handleLockClick}>
                            <Icon color={this.props.presupuesto.presupuesto.cerrado? 'error' : 'primary'} fontSize='large'>{this.props.presupuesto.presupuesto.cerrado ? 'lock' : 'lock_open'}</Icon>
                        </IconButton>
                    </FormControl>

                    {centros.find(c => c.id === this.state.centroSelected) !== undefined ?
                        this.renderGrid()
                        : ''}

                    {centros.find(c => c.id === this.state.centroSelected) !== undefined ?
                        <div className={classes.totales}>
                            <Typography variant="subtitle2" style={{ margin: '10px 8px' }}>{'% Bar / Bolera'}</Typography>
                            <TextField
                                disabled
                                id="barBolera"
                                value={this.props.presupuesto.presupuesto.barBolera * 100}
                                className={classes.input}
                                InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatPercentFormatInput }}
                                variant="outlined"
                            />

                            <Typography variant="subtitle2" style={{ margin: '10px 8px' }}>{'Ingresos totales'}</Typography>
                            <TextField
                                disabled
                                id="total"
                                value={this.props.presupuesto.presupuesto.total}
                                className={classes.input}
                                InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                                variant="outlined"
                            />
                        </div>
                        : ''}
                </div>


                {centros.find(c => c.id === this.state.centroSelected) !== undefined ?
                    <div className={classes.divOptions}>
                        <FormControl className={classes.formControl}>
                            <InputLabel>Año origen</InputLabel>
                            <Select
                                native
                                value={this.state.yearOrigenSelected}
                                onChange={(event) => this.handleYearOrigenValueChange(event)}
                                name={'year'}
                            >
                                {this.renderSelectOrigenYears()}

                            </Select>
                        </FormControl>
                        <FormControl component="fieldset" className={classes.formControl} variant='outlined'>
                            <RadioGroup row
                                aria-label="Option 1"
                                name="opt1"
                                className={classes.group}
                                value={this.state.realOrPpto}
                                onChange={(event) => this.handleRealChange(event)}
                            >
                                <FormControlLabel value={'ppto'} control={<Radio />} label={'Presupuesto'} />
                                <FormControlLabel value={'real'} control={<Radio />} label={'Real'} />
                            </RadioGroup>
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <InputLabel>Mes inicio</InputLabel>
                            <Select
                                native
                                value={this.state.startMonthOrigen}
                                onChange={(event) => this.handleStartMonthOrigenValueChange(event)}
                                name={'startMonth'}
                            >
                                {this.renderMonths()}

                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <InputLabel>Mes fin</InputLabel>
                            <Select
                                native
                                value={this.state.endMonthOrigen}
                                onChange={(event) => this.handleEndMonthOrigenValueChange(event)}
                                name={'endMonth'}
                            >
                                {this.renderMonths()}

                            </Select>
                        </FormControl>

                    </div>
                    : ''}

                {centros.find(c => c.id === this.state.centroSelected) !== undefined ?
                    this.renderGenerarPresupuestosGrid(centros)
                    : ''}

                {centros.find(c => c.id === this.state.centroSelected) !== undefined ?
                    <div>

                        <Button variant="contained" color="secondary" className={classes.buttonIncremento} onClick={() => {
                            this.props.openDialog('IncrPresupuestos', {
                                oldPresupuesto: this.state.totalRefPresupuesto,
                                okHandler: this.incrGrid,
                            }, uuidv4());
                        }}>{'Aplicar incremento'}</Button>

                        <TextField
                            disabled
                            id="totalRef"
                            value={this.state.totalRefPresupuesto}
                            className={classes.inputRefTotal}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                            variant="outlined"
                        />

                        <TextField
                            disabled
                            id="totalNew"
                            value={this.state.totalPresupuesto}
                            className={classes.inputNewTotal}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                            variant="outlined"
                        />

                        <TextField
                            disabled
                            id="totalPercent"
                            value={this.state.totalPercentPresupuesto}
                            className={classes.inputPercentTotal}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatPercentFormatInput }}
                            variant="outlined"
                        />


                    </div>
                    : ''}


                {centros.find(c => c.id === this.state.centroSelected) !== undefined ?
                    <Button variant="contained" color="primary" className={classes.button} disabled={this.props.presupuesto.presupuesto.cerrado || this.props.presupuesto.isLoading} onClick={() => {

                        this.props.generatePresupuesto(
                            this.state.centroSelected,
                            this.state.yearSelected,
                            this.state.yearOrigenSelected,
                            this.state.startMonthOrigen,
                            this.state.endMonthOrigen,
                            (this.state.realOrPpto === 'real'),
                            this.state.provisionalOrDefinitivo === 'provisional',
                            this.state.rowsGenerarPresupuesto
                        );
                    }}>Genera Presupuesto</Button>
                    : ''}

            </div>
        );
    }
}


EntPresupuestos.propTypes = {
    //state

    user: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,

};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centroDiaSelected: state.centroDiaSelected,
        centros: state.centros.centros,
        presupuesto: state.presupuesto,
        userProfile: state.userProfile
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getAllCentros,
        getPresupuesto,
        generatePresupuesto,
        setCentroDia,
        copiarPresupuesto,
        cambiarBloqueoPresupuesto,
        openDialog,
        hideDialog
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(EntPresupuestos));